import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AppInsightsMonitoringService } from '../logging/appInsightsMonitoring.service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

    constructor(
        private injector: Injector) {
        super();
    }

    private get appInsightsMonitoringService(): AppInsightsMonitoringService {
        return this.injector.get(AppInsightsMonitoringService);
      }
    /**
     * @description Given an Error object, perform the appropriate action.
     *
    */
    handleError(error: Error) {
        this. appInsightsMonitoringService.logException(error, 1); // Manually log exception

    }


}
